export function generateTransparentImage() {
  const image = new Image()
  image.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
  return image
}

export function injectClone(clone: HTMLDivElement, event: DragEvent, itemRec: DOMRect) {
  clone.classList.add('drag-clone')
  clone.style.pointerEvents = 'none'
  clone.style.position = 'absolute'
  // clone.setAttribute('data-dragged', 'true')
  clone.style.top = `${event.clientY}px`
  clone.style.left = `${event.clientX}px`
  clone.style.width = `${itemRec.width}px`
  clone.style.zIndex = '99999'
  document.body.appendChild(clone)
}
